import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { Row } from "@/components/General/Grid/row.component";

type CalculationGroupProps = RequireChildrenFor<{}>;

const CalculationGroup = ({ children }: CalculationGroupProps) => {
    return <Row className={cn("tw:group")}>{children}</Row>;
};

export { CalculationGroup };
